import { RecursiveObject } from '@chakra-ui/react';

export const fontSizes: RecursiveObject = {
  xs: '0.8125rem',
  xxs: '0.625rem',
  '4xl': '2rem',
};
